import { useState } from 'react';
import firebase from 'firebase/compat/app';

const functions = firebase.functions();

/**
 * GitHub-style confirmation modal for deleting a location
 * Requires user to type the location name to confirm
 */
export function DeleteLocationModal({ location, onClose, onSuccess }) {
  const [confirmName, setConfirmName] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const isConfirmValid = confirmName === location.name;

  const handleDelete = async () => {
    if (!isConfirmValid) {
      setError('Der Name stimmt nicht überein');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const deleteLocation = functions.httpsCallable('deleteLocation');
      await deleteLocation({
        locationId: location.id,
        confirmName
      });

      onSuccess();
    } catch (err) {
      // console statement removed for production
      setError(err.message || 'Fehler beim Löschen');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content modal-danger" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Standort löschen</h2>
          <button className="modal-close" onClick={onClose}>
            <i className="fas fa-times"></i>
          </button>
        </div>

        <div className="delete-warning">
          <i className="fas fa-exclamation-triangle"></i>
          <p>
            <strong>Achtung!</strong> Diese Aktion kann nicht rückgängig gemacht werden.
            Der Standort wird deaktiviert und ist nicht mehr sichtbar.
          </p>
        </div>

        <div className="form-group">
          <label>
            Bitte geben Sie <strong>{location.name}</strong> ein, um zu bestätigen:
          </label>
          <input
            type="text"
            value={confirmName}
            onChange={(e) => setConfirmName(e.target.value)}
            placeholder={location.name}
            autoComplete="off"
          />
        </div>

        {error && (
          <div className="error-message">{error}</div>
        )}

        <div className="modal-actions">
          <button type="button" onClick={onClose} disabled={loading}>
            Abbrechen
          </button>
          <button
            type="button"
            className="btn-danger"
            onClick={handleDelete}
            disabled={!isConfirmValid || loading}
          >
            {loading ? 'Löscht...' : 'Standort löschen'}
          </button>
        </div>
      </div>
    </div>
  );
}
